import create from 'zustand'

import type { State } from 'zustand'

export interface InspirationsStates extends State {
  inspirationMenuBadgeUpdated: boolean
  inspirationMenuHasBadge: boolean
  inspirationListScroll: number
  inspirationListBottomReached: boolean
  setInspirationMenuBadgeUpdated: (inspirationMenuBadgeUpdated: boolean) => void
  setInspirationMenuHasBadge: (inspirationMenuHasBadge: boolean) => void
  setInspirationListScroll: (inspirationListScroll: number) => void
  setInspirationListBottomReached: (
    inspirationListBottomReached: boolean
  ) => void
}

export const useInspirationsStore = create<InspirationsStates>((set) => ({
  inspirationMenuBadgeUpdated: false,
  inspirationMenuHasBadge: false,
  inspirationListScroll: 0,
  inspirationListBottomReached: false,
  setInspirationMenuBadgeUpdated: (inspirationMenuBadgeUpdated) =>
    set(() => ({ inspirationMenuBadgeUpdated })),
  setInspirationMenuHasBadge: (inspirationMenuHasBadge) =>
    set(() => ({ inspirationMenuHasBadge })),
  setInspirationListScroll: (inspirationListScroll) =>
    set(() => ({ inspirationListScroll })),
  setInspirationListBottomReached: (inspirationListBottomReached) =>
    set(() => ({ inspirationListBottomReached })),
}))
